import * as THREE from 'three';

export class Skybox {
    constructor(scene, starCount = 5000) {
        this.scene = scene;
        this.starCount = starCount;
        this.stars = null;
        this.init();
    }

    init() {
        // Create starfield
        const geometry = new THREE.BufferGeometry();
        const positions = [];
        const colors = [];
        
        const color = new THREE.Color();
        
        for (let i = 0; i < this.starCount; i++) {
            // Random position in sphere
            const radius = 500 + Math.random() * 4500;
            const theta = Math.random() * Math.PI * 2;
            const phi = Math.acos(Math.random() * 2 - 1);
            
            const x = radius * Math.sin(phi) * Math.cos(theta);
            const y = radius * Math.sin(phi) * Math.sin(theta);
            const z = radius * Math.cos(phi);
            
            positions.push(x, y, z);
            
            // Random star color (white to blue-white)
            const brightness = 0.5 + Math.random() * 0.5;
            const colorTemp = 0.9 + Math.random() * 0.1; // Slight blue tint
            color.setRGB(brightness, brightness * colorTemp, brightness);
            colors.push(color.r, color.g, color.b);
        }
        
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
        geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
        
        const material = new THREE.PointsMaterial({
            size: 2,
            sizeAttenuation: true,
            vertexColors: true,
            transparent: true,
            opacity: 0.9
        });
        
        this.stars = new THREE.Points(geometry, material);
        this.scene.add(this.stars);
    }

    update(deltaTime) {
        // Optional: rotate stars very slowly
        if (this.stars) {
            this.stars.rotation.y += 0.00001 * deltaTime;
        }
    }

    dispose() {
        if (this.stars) {
            this.stars.geometry.dispose();
            this.stars.material.dispose();
            this.scene.remove(this.stars);
            this.stars = null;
        }
    }
}
